import PracticeProfileError from './PracticeProfileError'

export default class PracticeSignupError extends PracticeProfileError {
  email: string[] = []
  password1: string[] = []
  password2: string[] = []
  first_name: string[] = []
  last_name: string[] = []
}